import type { LevelTwoConfig } from '@/feature-flags/types/variant.types';
import { DISABLED_LEVEL_TWO_CONFIG } from '@/feature-flags/types/variant.types';
import { logError, logInfo } from '@/feature-flags/utils/logger';

export function parseJsonAttachment<T>(
  attachment: string | null | undefined,
  fallback: T,
): T {
  if (!attachment) {
    return fallback;
  }

  try {
    const parsed = JSON.parse(attachment);

    if (typeof parsed !== 'object' || parsed === null) {
      logError('Attachment is not a valid JSON object', new Error('Invalid attachment type'), {
        attachment,
      });
      return fallback;
    }

    return parsed as T;
  } catch (error) {
    logError('Failed to parse attachment JSON', error, { attachment });
    return fallback;
  }
}

export function normalizeLevelTwoConfig(
  partial: Partial<LevelTwoConfig> | null | undefined,
): LevelTwoConfig {
  const normalized = { ...DISABLED_LEVEL_TWO_CONFIG };

  if (!partial || typeof partial !== 'object') {
    return normalized;
  }

  (Object.keys(DISABLED_LEVEL_TWO_CONFIG) as Array<keyof LevelTwoConfig>).forEach((key) => {
    if (typeof partial[key] === 'boolean') {
      normalized[key] = partial[key] as boolean;
    }
  });

  return normalized;
}

export function parseLevelTwoConfig(
  attachment: string | null | undefined,
): LevelTwoConfig {
  const parsed = parseJsonAttachment<Partial<LevelTwoConfig>>(
    attachment,
    DISABLED_LEVEL_TWO_CONFIG,
  );

  const normalized = normalizeLevelTwoConfig(parsed);

  logInfo('Level Two configuration parsed', { config: normalized });

  return normalized;
}
